import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

import type { TSchema } from 'infrastructure/functions';

export const medicalHistoryValidationSchema = (
  showTrackingPlatform?: boolean,
) =>
  createValidationSchema({
    record: commonValidationSchemas.string({ required: true }),
    trackingPlatform: showTrackingPlatform
      ? commonValidationSchemas.string({ required: true })
      : commonValidationSchemas.string(),
  });

export type Values = TSchema<ReturnType<typeof medicalHistoryValidationSchema>>;
